import { apiData } from '../../common/dataService';
import {
  getItem,
  setItem,
  bannerCookieManager,
  cookieManager
} from '../../common/utils';

const broadInfo = getItem('local', 'broadInfo');
// initial state
const state = {
  broadInfo: broadInfo ? JSON.parse(broadInfo) : {}
};

// getters
const getters = {};

//actions
const actions = {
  async getBroadCast({ commit, dispatch }, data) {
    let userInfo = getItem('local', 'twe_userInfo');
    let UUID = '';
    if (userInfo) {
      userInfo = JSON.parse(userInfo);
      UUID = userInfo.mobile ? userInfo.mobile : '';
    }
    let closeBroad = getItem('local', 'closeBroad');
    let id = bannerCookieManager.getItem('bannerId-' + UUID);
    let res = await apiData('get', 'user/getBroadcast');
    let now = new Date().getTime();
    let startTime = parseInt(res.startTime);
    /*在广播有效期内则展示*/
    if (now >= startTime && closeBroad != '1') {
      /*判断是否不再提示*/
      if (!id) {
        commit('setBroadCast', res);
      } else {
        if (res.id !== id) {
          /*广播有效期间点击了不再提示，bannerId存在，又来了一条新的广播*/
          commit('setBroadCast', res);
          bannerCookieManager.removeItem('bannerId-' + UUID);
        } else {
          commit('setBroadCast', {});
        }
      }
    } else {
      commit('setBroadCast', {});
    }
  }
};

// mutations
const mutations = {
  setBroadCast(state, data) {
    state.broadInfo = data;
    setItem('local', 'broadInfo', JSON.stringify(data));
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/broadCast.js